class o extends Error {
  constructor(e) {
    super(e), this.message = e, this.name = "MediaDataRoomOutdatedAudiencesNodeError";
  }
}
export {
  o as MediaDataRoomOutdatedAudiencesNodeError
};
//# sourceMappingURL=MediaDataRoomOutdatedAudiencesNodeError.js.map
